import { isEmptyExpressionValue } from '@shared/helpers/expression-factory.helpers';
import { getExpressionLineForNumericOverrideSolve } from '@shared/helpers/element-quantity-value-override.helpers';
import { guards } from '@shared/helpers/typeguards.helpers';
import type { ExpressionVariables } from '@shared/helpers/expression-variables.helpers';
import {
  fixNumberFormatSolve,
  formatExpressionErrorMessage,
  solve,
  type ISolveOptions,
} from '@shared/helpers/expression-solving.helpers';

/**
 * Pre-flight for numeric overrides: min/max on the typed value.
 * Stored formulas are not re-solved when they are non-literal — inherit/`gfa` on `count`
 * or `fallbackCount` can be NaN/Infinity while the override is valid.
 *
 * Literal expression lines (`"0"`, `"50"`) still go through {@link fixNumberFormatSolve}.
 */
export const validateExpressionNumericOverrideForApply = (
  overrideValue: number,
  expressionLine: string,
  variables: ExpressionVariables,
  solveOptions: ISolveOptions,
): Error | undefined => {
  try {
    const lineToSolve =
      getExpressionLineForNumericOverrideSolve(expressionLine);
    const normalized = fixNumberFormatSolve(
      overrideValue,
      lineToSolve,
      variables,
      solveOptions,
    );
    if (isEmptyExpressionValue(normalized)) return undefined;
    solve(normalized.value, '', variables, solveOptions);
    return undefined;
  } catch (e) {
    const err = guards.is.error(e) ? e : new Error(String(e));
    err.message = formatExpressionErrorMessage(err);
    return err;
  }
};
